<template>
  <b-modal
    v-if="!isMobile()"
    :hideHeaderClose="!isMobile()"
    hide-footer
    @hide="clearFields"
    ref="modal-primary"
    id="modal-primary"
    @cancel="clearFields"
    @close="clearFields"
    size="xl"
    modal-class="modal-primary"
    centered
    :title="$t('AddNewMarketplace')"
  >
    <b-row>
      <b-col lg="6" sm="12">
        <vs-card>
          <div>
            <form>
              <div class="vx-row">
                <div class="vx-col ml-auto flex">
                  <img :src="imgSrc" alt="" style="width: 150px" />
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col w-full">
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        class="vs-input--label"
                        :label="'* ' + $t('MpName')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <v-select
                        v-model="mpName"
                        :options="mpOPTION"
                        autocomplete
                        name="mpname"
                        v-validate="'required'"
                      >
                      </v-select>
                      <span class="text-danger text-sm" v-show="errors.has('mpname')">{{
                        errors.first("mpname")
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        class="vs-input--label"
                        :label="'* ' + $t('Prefix')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-input
                        class="vs-input--label"
                        size="sm"
                        id="h-first-name"
                        v-model="prefix"
                        name="prefix"
                        v-validate="'required'"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('prefix')">{{
                        errors.first("prefix")
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        class="vs-input--label"
                        label="* Api Key: "
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-input
                        class="vs-input--label"
                        size="sm"
                        id="h-first-name"
                        v-model="apiKey"
                        name="apikey"
                        v-validate="'required'"
												type="password"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('apikey')">{{
                        errors.first("apikey")
                      }}</span>
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        class="vs-input--label"
                        label="* Api User: "
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-input
                        size="sm"
                        id="h-first-name"
                        v-model="apiUser"
                        name="apiuser"
                        v-validate="'required'"
												type="password"
                      />
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        class="vs-input--label"
                        label="* Api Password: "
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-input
                        size="sm"
                        id="h-first-name"
                        v-model="apiPassword"
                        name="apipassword"
                        v-validate="'required'"
												type="password"
                      />
                    </b-col>
                  </b-row>
                </div>
              </div>
            </form>
          </div>

          <div class="items-center pl-6 mt-5 mb-0">
            <b-row align-h="end">
              <b-col cols="3" md="auto" style="padding: 0px">
                <b-button
                  class="bg-danger"
                  style="border-color: white"
                  v-on:click="initValues"
                >
                  <Icon
                    icon="material-symbols:cancel-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Cancel") }}
                </b-button>
              </b-col>
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="addCustomerInfo()"
                >
                  <Icon
                    icon="material-symbols:save-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Save") }}
                </b-button>
              </b-col>
            </b-row>
          </div>
        </vs-card>
      </b-col>
      <b-col lg="6" sm="12">
        <vx-card>
          <component
            :is="scrollbarTag"
            ref="scroll"
            class="scroll-area--data-list-add-new"
            :settings="settings"
            :key="$vs.rtl"
          >
            <VxTimelineCustomerInfo :data="timelineData">
              <template #update-buttons="item">
                <b-button
                  variant="outline-light"
                  @click="
                    updatedItem = item.data;
                    setDataValues(item);
                  "
                  style="
                    border: none;
                    background: none;
                    margin-right: 0px;
                    padding-right: 0px;
                  "
                >
                  <Icon
                    icon="ep:edit"
                    color="#7367F0"
                    width="18"
                    height="18"
                    v-b-tooltip.hover.bottom="'Güncelle'"
                  />
                </b-button>
                <b-button
                  variant="outline-light"
                  @click="
                    updatedItem = item.data;
                    deleteCustomerInfo(item.data.CompanyInfoId);
                  "
                  style="border: none; background: none"
                >
                  <Icon
                    icon="ph:trash-fill"
                    color="#FF9F43"
                    width="18"
                    height="18"
                    v-b-tooltip.hover.bottom="'Sil'"
                  />
                </b-button>
              </template>

              <template #action-buttons="{ isDone, id, color, icon }">
                <div
                  @click="isDone == false ? findWorkflowId(id, 1) : findWorkflowId(id, 0)"
                  class="timeline-icon"
                  :class="`bg-${color}`"
                >
                  <feather-icon
                    :icon="icon"
                    svgClasses="text-white stroke-current w-5 h-5"
                  />
                </div>
              </template>
            </VxTimelineCustomerInfo>
          </component>
        </vx-card>
      </b-col>
    </b-row>
  </b-modal>
  <vs-popup
    v-else
    :title="$t('MpAdd')"
    button-cancel="border"
    @cancel="clearFields"
    @close="clearFields"
    :active.sync="isSidebarActiveLocal"
    classContent="popup-example"
  >
    <b-row>
      <b-col lg="6" sm="12">
        <vs-card>
          <div>
            <form>
              <div class="vx-row">
                <div class="vx-col ml-auto flex">
                  <img :src="imgSrc" alt="" style="width: 150px" />
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col w-full">
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        class="vs-input--label"
                        :label="'* ' + $t('MpName')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <v-select
                        v-model="mpName"
                        :options="mpOPTION"
                        autocomplete
                        name="mpname"
                        v-validate="'required'"
                      >
                      </v-select>
                      <span class="text-danger text-sm" v-show="errors.has('mpname')">{{
                        errors.first("mpname")
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        class="vs-input--label"
                        :label="'* ' + $t('Prefix')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-input
                        class="vs-input--label"
                        size="sm"
                        id="h-first-name"
                        v-model="prefix"
                        name="prefix"
                        v-validate="'required'"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('prefix')">{{
                        errors.first("prefix")
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        class="vs-input--label"
                        label="* Api Key: "
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-input
                        class="vs-input--label"
                        size="sm"
                        id="h-first-name"
                        v-model="apiKey"
                        name="apikey"
                        v-validate="'required'"
												type="password"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('apikey')">{{
                        errors.first("apikey")
                      }}</span>
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        class="vs-input--label"
                        label="* Api User: "
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-input
                        size="sm"
                        id="h-first-name"
                        v-model="apiUser"
                        name="apiuser"
                        v-validate="'required'"
												type="password"
                      />
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        class="vs-input--label"
                        label="* Api Password: "
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-input
                        size="sm"
                        id="h-first-name"
                        v-model="apiPassword"
                        name="apipassword"
                        v-validate="'required'"
												type="password"
                      />
                    </b-col>
                  </b-row>
                </div>
              </div>
            </form>
          </div>

          <div class="items-center pl-6 mt-5 mb-0">
            <b-row align-h="end">
              <b-col md="auto" style="width: auto;padding: 0px">
                <b-button
                  class="bg-danger"
                  style="border-color: white"
                  v-on:click="initValues"
                >
                  <Icon
                    icon="material-symbols:cancel-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Cancel") }}
                </b-button>
              </b-col>
              <b-col md="auto" style="width: auto;">
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="addCustomerInfo()"
                >
                  <Icon
                    icon="material-symbols:save-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Save") }}
                </b-button>
              </b-col>
            </b-row>
          </div>
        </vs-card>
      </b-col>
      <b-col lg="6" sm="12">
        <vx-card>
          <component
            :is="scrollbarTag"
            ref="scroll"
            class="scroll-area--data-list-add-new-mobile"
            :settings="settings"
            :key="$vs.rtl"
          >
            <VxTimelineCustomerInfo :data="timelineData">
              <template #update-buttons="item">
                <b-button
                  variant="outline-light"
                  @click="
                    updatedItem = item.data;
                    setDataValues(item);
                  "
                  style="
                    border: none;
                    background: none;
                    margin-right: 0px;
                    padding-right: 0px;
                  "
                >
                  <Icon
                    icon="ep:edit"
                    color="#7367F0"
                    width="18"
                    height="18"
                    v-b-tooltip.hover.bottom="'Güncelle'"
                  />
                </b-button>
                <b-button
                  variant="outline-light"
                  @click="
                    updatedItem = item.data;
                    deleteCustomerInfo(item.data.CompanyInfoId);
                  "
                  style="border: none; background: none"
                >
                  <Icon
                    icon="ph:trash-fill"
                    color="#FF9F43"
                    width="18"
                    height="18"
                    v-b-tooltip.hover.bottom="'Sil'"
                  />
                </b-button>
              </template>

              <template #action-buttons="{ isDone, id, color, icon }">
                <div
                  @click="isDone == false ? findWorkflowId(id, 1) : findWorkflowId(id, 0)"
                  class="timeline-icon"
                  :class="`bg-${color}`"
                >
                  <feather-icon
                    :icon="icon"
                    svgClasses="text-white stroke-current w-5 h-5"
                  />
                </div>
              </template>
            </VxTimelineCustomerInfo>
          </component>
        </vx-card>
      </b-col>
    </b-row>
  </vs-popup>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { Validator } from "vee-validate";
import VxTimelineCustomerInfo from "@/components/timeline/VxTimelineCustomerInfo";
import { uuid } from "vue-uuid";
import { Icon } from "@iconify/vue2";
import vSelect from "vue-select";
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
export default {
  props: {
    isSidebarInfoActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    DeleteWarning,
    VxTimelineCustomerInfo,
    Icon,
    "v-select": vSelect,
  },
  watch: {
    mpNameList(val) { 
      this.getMpNameOptions();
      return val;
    },
    isSidebarInfoActive(val) {
      if (val && !this.isMobile()) this.$refs["modal-primary"].show();
      else if (!val && !this.isMobile()) this.$refs["modal-primary"].hide();
      this.getCustomerInfo(this.data.CompanyId);
      this.imgSrc = "data:image/jpeg;base64," + this.data.CompanyLogo;
      return val;
    },
  },
  data() {
    return {
      isMobile: function () {
        return isMobile;
      },
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      updatedItem: [],
      deleteWarningPromptValid2: false,
      customerInfoList: [],
      timelineData: [],
      prefix: "",
      imgSrc: "",
      companyInfoId: "",
      mpName: "",
      apiKey: "",
      apiPassword: "",
      apiUser: "",
      mpOPTION: [],
    };
  },
  methods: {
    getMpNameOptions() {
      this.mpNameListOption = [];
      this.mpOPTION = [];
      this.mpNameListOption = this.mpNameList; 
      this.mpOPTION = Object.values(this.mpNameListOption);
    },
    closeDeleteWarning() {
      this.deleteWarningPromptValid2 = false;
    },
    deleteCustomerInfo(data) {
      const vs = this.$vs;
      this.$store
        .dispatch("customer/deleteCustomerInfo", data)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.getCustomerInfo(this.data.CompanyId);
              this.$root.$emit("getCustomerinfoList");
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    getCustomerInfo(item) {
      const vs = this.$vs;
      this.timelineData = [];
      this.$store
        .dispatch("customer/listCustomerInfoForCustomer", item)
        .then((response) => {
          // let costumerList = JSON.parse(response.json);
          if (response.success == true) {
            this.customerInfoList = this.$store.state.customer.CustomerInfoListForCustomer;

            this.customerInfoList.forEach((val, index) => {
              this.timelineData.push({
                color: "primary",
                icon: "CheckIcon",
                title: val.Name,
                desc: val.ApiKey,
                data: val,
                id: val.CompanyInfoId,
              });
            });
          } else console.log(response.statusText);
          /*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
        });
    },
    addCustomerInfo() {
      var createdId = uuid.v4();
      const vs = this.$vs;
      this.$validator.validateAll().then((result) => {
        if (result) {
          const obj = {
            companyInfoId: this.companyInfoId != "" ? this.companyInfoId : createdId,
            companyInfoType: 1,
            name: this.mpName,
            apiKey: this.apiKey,
            apiUser: this.apiUser,
            apiPassword: this.apiPassword,
            companyId: this.data.CompanyId,
            prefix: this.prefix,
          };

          if (this.companyInfoId != "") {
            this.$store
              .dispatch("customer/updateCustomerInfo", obj)
              .then((response) => {
                if (response.status == 200) {
                  vs.notify({
                    text: response.data.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                  this.getCustomerInfo(this.data.CompanyId);
                  this.$root.$emit("getCustomerinfoList");
                  this.$emit("closeSidebar");
                  this.initValues();
                } else {
                  vs.notify({
                    text: response.data.message.toString(),
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              })
              .catch((error) => {
                return new Promise((resolve, reject) => {
                  resolve(false);
                });
              });
          } else {
            delete obj.id;
            obj.popularity = 0;
            this.$store
              .dispatch("customer/addCustomerInfo", obj)
              .then((response) => {
                if (response.status == 200) {
                  vs.notify({
                    text: response.data.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                  this.getCustomerInfo(this.data.CompanyId);
                  this.$root.$emit("getCustomerinfoList");

                  this.$emit("closeSidebar");
                  this.initValues();
                } else {
                  vs.notify({
                    text: response.data.message.toString(),
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              })
              .catch((error) => {
                return new Promise((resolve, reject) => {
                  resolve(false);
                });
              });
          }
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },

    setDataValues(item) {
      this.companyInfoId = item.data.CompanyInfoId;
      this.companyInfoType = item.data.CompanyInfoType;
      this.companyId = item.data.CompanyId;
      this.mpName = item.data.Name;
      this.apiKey = item.data.ApiKey;
      this.apiPassword = item.data.ApiPassword;
      this.apiUser = item.data.ApiUser;
      this.prefix = item.data.Prefix;
    },
    initValues() {
      this.companyInfoId = "";
      this.mpName = "";
      this.apiKey = "";
      this.apiUser = "";
      this.apiPassword = "";
      this.companyId = "";
      this.customer = "";
      this.customerinfo = "";
      this.prefix = "";
    },
    clearFields() {
      this.$root.$emit("closeInfoData");
      this.companyInfoId = "";
      this.mpName = "";
      this.apiKey = "";
      this.apiUser = "";
      this.apiPassword = "";
      this.companyId = "";
      this.customer = "";
      this.customerinfo = "";
      this.prefix = "";
    },
  },
  mounted() {
    this.$root.$on("editDataTimelineCustomerInfo", (data) => {
      this.setDataValues(data);
    });
    this.$root.$on("deleteData2", (data) => {
      this.deleteData2 = data;
      this.deleteCustomer(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("editDataTimelineCustomerInfo");
    this.$root.$off("deleteData2");
  },
  created() {
		this.getMpNameOptions();
    const dict = {
      custom: {
        prefix: {
          required: this.$t("apiprefixRequired"),
          alpha: this.$t("apiprefixRequired"),
        },
        apipassword: {
          required: this.$t("apipasswordRequired"),
          alpha: this.$t("apipasswordRequired"),
        },
        apiuser: {
          required: this.$t("apiuserRequired"),
          alpha: this.$t("apiuserRequired"),
        },
        apikey: {
          required: this.$t("apiKeyRequired"),
          alpha: this.$t("apiKeyRequired"),
        },
        mpname: {
          required: this.$t("mpnameRequired"),
          alpha: this.$t("mpnameRequired"),
        },
      },
    };
    Validator.localize("en", dict);
  },
  computed: {
    mpNameList: {
      get() {
        return this.$store.state.order.MpNameList;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarInfoActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
};
</script>
<style lang="scss" scoped>
.vs-input--label {
  color: black;
  font-size: small;
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 120px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.scroll-area--data-list-add-new-mobile {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 400px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
[dir] .modal-title {
  margin-bottom: 0;
  color: #7367f0 !important;
}

#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
</style>
